export const environment = {
  production: false,
  BASE_ACS_URL: 'https://ubo.stage.dm.everymatrix.com/',
  AIRFLOW_ONCE_URL:
    'https://airflow-int.stage.dm.everymatrix.net/api/v1/dags/UBO_Reports_Run_Once/dagRuns',
  AIRFLOW_PERIODICALLY_URL:
    'https://airflow-int.stage.dm.everymatrix.net/api/v1/dags/UBO_Reports__Generator/dagRuns',
};
